import { FC } from 'react';
import { StockStatusComponentType } from '../Molecules';
import { ResultCardComponent } from '../Organisms';
import type { SearchResultCardComponentPropsTypes } from './types/propsTypes';

export const SearchResultCardComponent: FC<SearchResultCardComponentPropsTypes> = (
  props: SearchResultCardComponentPropsTypes,
): JSX.Element => (
  <ResultCardComponent
    {...props}
    showComponentCollection={{
      showAddToCartButtonComp: true,
      showPVBVComp: false,
      showStockStatusComp: true,
    }}
    stockStatusType={StockStatusComponentType.STOCK_STATUS_SEARCH_RESULT_CARD}
    isMinProjection={false}
    showZeroAsFree={false}
  />
);

export type { SearchResultCardComponentPropsTypes };
